import {
  adminControlFeatures,
  codeScanningFeatures,
  complianceFeatures,
  deploymentFeatures,
  type FullTierDescription,
  mainFeatures,
  qualityFeatures,
  reportingFeatures,
  sbomFeatures,
  securityFeatures,
  supportFeatures,
} from './consts';

const businessTierFeatures: FullTierDescription = {
  mainFeatures: {
    [mainFeatures.projectsFeature]: '10',
    [mainFeatures.contributingDevelopers]: '',
    [mainFeatures.releaseGroupsFeature]: '1',
    [mainFeatures.continuousMonitoringFeature]: true,
    [mainFeatures.apiSupportFeature]: true,
    [mainFeatures.packageIndexFeature]: false,
    [mainFeatures.issueDashboardFeature]: true,
    [mainFeatures.autoIgnoreRulesFeature]: true,
    [mainFeatures.issueFiltersFeature]: true,
    [mainFeatures.savedFiltersFeature]: true,
  },
  codeScanningFeatures: {
    [codeScanningFeatures.sourceCodeScanningFeature]: true,
    [codeScanningFeatures.deepDepDiscoveryFeature]: true,
    [codeScanningFeatures.quickImportGitHubFeature]: true,
    [codeScanningFeatures.cicdIntegrationFeature]: true,
    [codeScanningFeatures.branchTagScanningFeature]: true,
    [codeScanningFeatures.containerScanningFeature]: true,
    [codeScanningFeatures.archiveScanningFeature]: false,
  },
  securityFeatures: {
    [securityFeatures.vulnIdentificationFeature]: true,
    [securityFeatures.vulnManagementFeature]: true,
    [securityFeatures.defaultSecurityPoliciesFeature]: true,
    [securityFeatures.customizeableSecurityPoliciesFeature]: true,
    [securityFeatures.basicIssueFilterSortFeature]: true,
    [securityFeatures.advancedIssueFilterSortFeature]: true,
  },
  complianceFeatures: {
    [complianceFeatures.licenseIdentificationFeature]: true,
    [complianceFeatures.licensingPolicyManagementFeature]: true,
    [complianceFeatures.discoveredLicensesFeature]: true,
    [complianceFeatures.defaultLicensePoliciesFeature]: true,
    [complianceFeatures.customizeableLicensePoliciesFeature]: true,
  },
  qualityFeatures: {
    [qualityFeatures.packageHealthSignalsFeature]: true,
    [qualityFeatures.defaultQualityPoliciesFeature]: true,
    [qualityFeatures.customizeableQualityPoliciesFeature]: true,
  },
  sbomFeatures: {
    [sbomFeatures.sbomGenerationFeature]: true,
    [sbomFeatures.sbomImportFeature]: '10',
    [sbomFeatures.sbomExportFeature]: true,
    [sbomFeatures.vexAnnotationsFeature]: true,
    [sbomFeatures.appSbomFeature]: true,
    [sbomFeatures.publicSbomFeature]: true,
    [sbomFeatures.privateSbomFeature]: false,
  },
  reportingFeatures: {
    [reportingFeatures.attributionReportFeature]: true,
    [reportingFeatures.auditDueDiligenceReportFeature]: true,
    [reportingFeatures.globalBundleFeature]: false,
    [reportingFeatures.issueOverviewFeature]: true,
  },
  adminControlFeatures: {
    [adminControlFeatures.auditLogsFeature]: false,
    [adminControlFeatures.jiraIntegrationFeature]: true,
    [adminControlFeatures.slackIntegrationFeature]: true,
    [adminControlFeatures.ssoFeature]: false,
    [adminControlFeatures.rbacFeature]: false,
    [adminControlFeatures.teamFeature]: false,
  },
  supportFeatures: {
    [supportFeatures.priorityEmailFeature]: true,
    [supportFeatures.onboardingAndSupportFeature]: false,
    [supportFeatures.slaFeature]: false,
  },
  deploymentFeatures: {
    [deploymentFeatures.saasDeploymentFeature]: true,
    [deploymentFeatures.managedSaasDeploymentFeature]: false,
    [deploymentFeatures.onPremDeploymentFeature]: false,
  },
};

export default businessTierFeatures;
